import React, { useEffect, useState } from 'react';
import './BridalMakeup.css';
import { Link } from 'react-router-dom';
import { getPartyImages } from '../../services/galleryService';

const PartyMakeup = () => {
  const [images, setImages] = useState([]);
  const [current, setCurrent] = useState(0);
  const [drawerOpen, setDrawerOpen] = useState(false);

  useEffect(() => {
    getPartyImages().then(setImages);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [images]);

  const toggleDrawer = () => setDrawerOpen(!drawerOpen);

  return (
    <div className="bridal-page">
      <div className=" slide-up">
        <h1 className="page-title">Party Makeup</h1>
      </div>

      <div className="gallery-section">
        {images.length > 0 && <img src={images[current]} alt="main" className="main-image" />}
        <div className="thumbnail-strip">
          {images.map((img, index) => (
            <img
              key={index}
              src={img}
              alt={`thumb-${index}`}
              className={`thumbnail ${current === index ? 'active' : ''}`}
              onClick={() => setCurrent(index)}
            />
          ))}
        </div>
      </div>

      <div className="buttons-container">
        <button
          className="drawer-toggle-btn"
          onClick={toggleDrawer}
        >
          All You Need to Know About Party Makeup ▾
        </button>
{drawerOpen && (
        <div className="drawer-content">
          <p>Why Should Brides Have All the Fun? Let’s be honest — glam isn’t just for the bride! Whether you’ve got a big birthday coming up, your BFF is getting married, or you’ve got a family party where you just have to serve looks — we’ve got your back [and your face;)].</p>
          <p>We’re pros at making you look gorgeous without the stress. And yes, that includes understanding your vibe — whether you’re going full glam, soft glam, or still deciding somewhere between “subtle glow” and “red carpet moment.”</p>
          <p>And let’s not forget our beautiful moms! We know they have their signature colour choices (hello, maroon and gold forever), and we respect those beautiful under-eyes that have seen things. If they want to keep it natural, we’re all for it — but if they want to knock a few years off with some concealer magic, we’re on it!</p>
          <p><strong>Party-Ready Glam Includes:</strong></p>
          <ul>
            <li>💄 High-Definition Makeup—because you deserve camera-ready glow</li>
            <li>💇‍♀️ Hairstyling—elegant, effortless, and exactly what you want</li>
            <li>👁️ Real Hair Lashes — soft, fluttery, and fabulous</li>
            <li>🎨 Top-Quality Coloured Lenses — for that extra sparkle and oomph factor</li>
            <li>👗 Draping for Sarees & Dupattas — securely styled to suit your outfit and shape</li>
          </ul>
          <p>📝 Just a heads-up: Hair extensions, hair accessories, real flowers, and travel to the venue are not included — but can totally be arranged separately!</p>
          <p>So whether you’re the birthday queen, the bride’s sister, the glowing mom, or the guest who’s ready to turn heads — we’ve got your glam covered.</p>
          <p>All you need to do is show up and shine. For more details, <a href="/make-an-enquiry">make an enquiry</a>.</p>
          <p><strong>NOTE- WE TAKE BULK BOOKINGS FOR GUEST MAKEUP. PACKAGES AVAILABLE FOR GUEST MAKEUP WITH SHRIJI AGARWAL AND TEAM.</strong></p>
        </div>
      )}

        <button
          className="primary-btn"
          onClick={() => window.location.href = "/make-an-enquiry"}
        >
          Make an Enquiry
        </button>

        
      </div>

      
    </div>
  );
};

export default PartyMakeup;